import { Configuration } from "@azure/msal-browser";

export const msalConfigB2E: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID as string,
    authority: 'https://login.microsoftonline.com/006c1e48-e342-47e9-ab5d-0dd9ff89bd96',
    redirectUri: `${window.location.origin}`,
    navigateToLoginRequestUrl: false,
    postLogoutRedirectUri: `${window.location.origin}`,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["openid", "profile"],
};